import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Logo from "../assets/images/logo-white.png";
import { handleLogin } from "../helpers/AuthHelper";
import ReactLoading from "react-loading";
import Lottie from "react-lottie";


class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoad: true,
      email: '',
      password: '',
      loading: false,
      loadingText: false,
      rememberMe: false
    }
  }
  componentDidMount() {
    if (this.props.isLoggedin) {
      this.props.history.push('/dashboard');
      return;
    }
    setTimeout(() => {
      this.setState({
        isLoad: false,
      })
    }, 500);
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
  }
  componentDidUpdate(prevProps) {
    if (this.props.isLoggedin && !prevProps.isLoggedin) {
      this.props.history.push('/dashboard');
    }
  }

  handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    this.setState(prevState => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const loadingMessages = [
      "Kullanıcı bilgileri alınıyor...",
      "Servis bilgileri alınıyor...",
      "Şube bilgileri alınıyor...",
      "Sistem bilgileri alınıyor...",
      "Lütfen bekleyin..."
    ];

    const updateLoadingText = async () => {
      for (let i = 0; i < loadingMessages.length; i++) {
        this.setState({ loadingText: loadingMessages[i] });
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
    };

    try {
      await Promise.all([
        updateLoadingText(),
        this.props.handleLogin({
          email: this.state.email,
          password: this.state.password,
          rememberMe: this.state.rememberMe
        })
      ]);

      this.setState({ loading: false });
      this.props.history.push('/dashboard');
    } catch (error) {
      this.setState({ loading: false });
      if (error.response?.status === 403 && error.response.data?.requires_verification) {
        this.props.history.push('/registration', { verificationEmail: error.response.data.email || this.state.email });
      }
    }
  };
  render() {
    const loading = this.state.loading;
    const loadingText = this.state.loadingText;
    const lottieOption = {
      loop: true,
      autoplay: true,
      animationData: require('../assets/assets/login.json'),
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice"
      }

    }
    return (
      <div className="theme-cyan">
        <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
          <div className="loader">
            <div className="m-t-30">
              <img src={require('../assets/images/logo-white.png')} width="150" alt="Lucid" />
            </div>
            <p>Lütfen Bekleyin...</p>
          </div>
        </div>
        <div className="hide-border">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main" style={{ position: "relative" }}>
              {/* Lottie Animasyonu */}
              <div className="hidden-xs hidden-sm"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "75%",
                  width: "40%",
                  height: "100%",
                  transform: "translate(-50%, -50%)",
                  zIndex: -1,
                  overflow: "hidden",
                }}
              >
                <Lottie options={lottieOption} height="100%" width="100%" />
              </div>
              <div className="auth-box">
                <div className="top">
                  <img src={Logo} alt="Servicezone" style={{ width: "190px", margin: "10px" }} />
                </div>
                <div className="card">
                  <div className="header">
                    <p className="lead">Giriş yap</p>
                  </div>
                  <div className="body">
                    <div className="form-auth-small">
                      <form onSubmit={this.handleSubmit}>
                        <div className="form-group">
                          <label className="control-label sr-only">Email</label>
                          <input
                            className="form-control"
                            id="email"
                            placeholder="Email Adresiniz"
                            type="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group">
                          <label className="control-label sr-only">
                            Şifre
                          </label>
                          <input
                            className="form-control"
                            id="password"
                            placeholder="Şifreniz"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                          />
                        </div>
                        <div className="form-group clearfix">
                          <label className="fancy-checkbox element-left">
                            <input name="rememberMe" id="rememberMe" type="checkbox" />
                            <span>Beni Hatırla</span>
                          </label>
                        </div>
                        {loading ? (
                          <button className="btn btn-primary btn-lg btn-block" disabled={true} style={{ textAlign: "-webkit-center" }}>
                            {loadingText || "lütfen bekleyin..."}<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"></ReactLoading>
                          </button>
                        ) :
                          <button className="btn btn-primary btn-lg btn-block" type="submit">
                            Giriş Yap
                          </button>}
                      </form>
                      <div className="bottom">
                        <span className="helper-text m-b-10">
                          <i className="fa fa-lock"></i>{" "}
                          <a href={`${process.env.PUBLIC_URL}/forgotpassword`}
                          >Şifremi Unuttum?
                          </a>
                        </span>
                        <span>
                          Hesabınız Yokmu?{" "}
                          <a href="registration" >Kayıt ol</a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  history: PropTypes.object.isRequired,
  handleLogin: PropTypes.func.isRequired,
  isLoggedin: PropTypes.bool.isRequired,
};
const mapStateToProps = (state) => ({
  isLoggedin: state.loginReducer.isLoggedin,
});

export default connect(mapStateToProps, { handleLogin })(Login);
